import { DateTime } from 'luxon';

import { AvailableHourRange } from '../models/Sessions';

export const formatAvailableHours = (availableHours: AvailableHourRange[] = []) =>
  availableHours.map((range) => ({
    ...range,
    start: range.start ? DateTime.fromFormat(range.start, 'h:mm a').toFormat('HH:mm') : '',
    end: range.end ? DateTime.fromFormat(range.end, 'h:mm a').toFormat('HH:mm') : '',
  }));
